import script from "./SuperCostReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperCostReport.vue?vue&type=script&setup=true&lang=js"

import "./SuperCostReport.vue?vue&type=style&index=0&id=1442599c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1442599c"]])

export default __exports__